/**
 * Tiny stale-while-revalidate (SWR) localStorage helper.
 *
 * Pattern used by Netflix / Hotstar / Spotify: on revisit, paint the previous
 * session's rails INSTANTLY from localStorage, then quietly refresh in the
 * background. The user perceives the page as already loaded.
 *
 * Storage limits: localStorage ~5MB per origin. A home-bundle is ~50KB so we
 * can easily hold dozens of cached responses without issue.
 *
 * Bump CACHE_VERSION when changing the response shape so old entries are
 * ignored after a deploy.
 */
const CACHE_VERSION = "v4";  // v2.77 — bumped to invalidate stale recent_india FIFO order across all clients
const DEFAULT_STALE_MS = 24 * 60 * 60 * 1000; // 24h

function key(k) {
  return `swr:${CACHE_VERSION}:${k}`;
}

export function readSwrCache(k, maxAgeMs = DEFAULT_STALE_MS) {
  try {
    const raw = localStorage.getItem(key(k));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    if (Date.now() - (parsed.t || 0) > maxAgeMs) return null;
    return parsed.d;
  } catch {
    return null;
  }
}

export function writeSwrCache(k, data) {
  try {
    localStorage.setItem(key(k), JSON.stringify({ t: Date.now(), d: data }));
  } catch {
    // QuotaExceededError — silently drop. Eviction is handled by the browser
    // automatically on next allocation.
  }
}
